import { useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Typography, Box, Menu, MenuItem, Tooltip } from '@mui/material';
import { useSelector } from '../../redux/store';
import Iconify from '../iconify';
import { useUpdateOrderItemRedux } from '../../hooks/useUpdateOrderItemRedux';
import { useScopeCheck } from '../scopes';

Category.propTypes = {
  row: PropTypes.object,
  disabled: PropTypes.bool
};

export default function Category({ row, disabled = false }) {  
  const { id = '' } = useParams();
  const updateOrderItemRedux = useUpdateOrderItemRedux();
  const hasAccess = useScopeCheck(['Edit-Order'], true);
  const { orderById } = useSelector((state) => state.orders || {});
  const { items = [], orderAgoraCategories = [] } = orderById[id] || {};
  const permittedCategoryIds = new Set(orderAgoraCategories.map((category) => category.id));
  const canEditCategories = hasAccess && items.every(
    (item) => item.agoraCategory?.id === 0 || permittedCategoryIds.has(item.agoraCategory?.id)
  );
  const tooltipTitle = !disabled && !canEditCategories
    ? 'You are not permitted to change categories in this order'
    : !disabled ? row.agoraCategory?.name || '' : '';
  const [anchorEl, setAnchorEl] = useState(null);
    const open = canEditCategories && Boolean(anchorEl);
    const handleClick = (event) => { 
        setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    };
  return (
    <>
      <Tooltip title={tooltipTitle}>
          {canEditCategories && !disabled ? (
          <Typography
            // color={stringToColor(row.agoraCategory?.name)}
            variant="subtitle2"
            sx={{
              border: 1,
              width: '105px',
              borderRadius: '3px',
              position: 'relative',
              display: 'flex', // Use flexbox
              alignItems: 'center',
              '&:hover': {
                cursor: 'pointer',
                backgroundColor: `#C4CDD5`,
              },
              my: '4px',
              py: '2px',
              px: 0.5,
            }}
            onClick={handleClick}
          >
            <Box
              sx={{
                flexGrow: 1,
                overflow: 'hidden', // Hide overflow
                textOverflow: 'ellipsis', // Add ellipsis for overflow
                whiteSpace: 'nowrap', // Prevent wrapping
                pr: 2,
              }}
            >
              {row?.agoraCategory?.name || ''}
            </Box>
            <Box>
              <Iconify icon={'mdi:chevron-down'} />
            </Box>
          </Typography>
        ) : (
          <Typography
            variant="subtitle2"
            sx={{
              border: 1,
              width: '100px',
              borderRadius: '3px',
              position: 'relative',
              display: 'flex', // Use flexbox
              alignItems: 'center',
              my: '4px',
              py: '5px',
              px: 0.5,
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                overflow: 'hidden', // Hide overflow
                textOverflow: 'ellipsis', // Add ellipsis for overflow
                whiteSpace: 'nowrap', // Prevent wrapping
                pr: 2,
              }}
            >
                {row?.agoraCategory?.name || '\u00A0'}
            </Box>
          </Typography>
        )}
      </Tooltip>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {[...(orderAgoraCategories || [])]
          .sort((a, b) => (a?.name || '').localeCompare(b?.name || '', 'en', { sensitivity: 'base' }))
          .map((category) => (
          <MenuItem
            key={category?.id}
            onClick={() => {
              updateOrderItemRedux(row?.id, 'agoraCategory', { id: category?.id, name: category?.name });
              if (row.agoraSubcategory.mainCategoryId !== category?.id) {
                updateOrderItemRedux(row?.id, 'agoraSubcategory', { id: 0, name: '', mainCategoryId: category?.id });
              }
              handleClose();
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              {category?.name}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
